import { ReactNode, useEffect, useRef, useState } from 'react';
import { CollapseContainer } from './styles';

interface CollapseProps {
  isOpen: boolean;
  children: ReactNode;
  hasBoxShadow?: boolean;
  hasMarginBottom?: boolean;
}

export const Collapse: React.FC<CollapseProps> = ({
  isOpen,
  children,
  hasBoxShadow = true,
  hasMarginBottom = true,
}) => {
  const [contentHeight, setContentHeight] = useState<number>(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = contentRef.current;
    if (!element) return;

    const updateHeight = () => {
      setContentHeight(element.scrollHeight);
    };

    updateHeight();

    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    const observer = new ResizeObserver(() => {
      updateHeight();
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [isOpen]);

  useEffect(() => {
    if (contentRef.current && isOpen) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [children, isOpen]);

  return (
    <CollapseContainer
      $isOpen={isOpen}
      $contentHeight={contentHeight}
      $hasBoxShadow={hasBoxShadow}
      $hasMarginBottom={hasMarginBottom}
    >
      <div ref={contentRef}>{children}</div>
    </CollapseContainer>
  );
};
